import React, { Component } from "react"
import { Icon } from '@driftt/tide-core-legacy'
import Select, { Creatable } from 'react-select-plus'
import classnames from 'classnames'


class OwnerMappingRow extends Component {

  renderIntegrationLoader = (index) => {
    const shouldShow = (this.props.hasActiveSearch === index) && this.props.isSearching
    return <span className={classnames({ 'inline-loading': shouldShow })}/>
  }

  renderIntegrationUserDropdown() {
    const { integrationName, getUserOptions, saveOption, searchUsers, index, mapping } = this.props
    const userId = mapping.integrationUserId

    const selectOptions = {
      placeholder: `Search ${integrationName} Users...`,
      value: userId,
      options: getUserOptions(userId),
      searchable: true,
      isOpen: this.props.hasActiveSearch === index,
      pageSize: 10,
      arrowRenderer: () => this.renderIntegrationLoader(index),
      onChange: value => saveOption(value, index), 
      onInputChange: query => searchUsers(query, index)
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderDriftUserDropdown() {
    const { saveUserOption, mapping, index, openInviteModal } = this.props
    const driftUserId = mapping.driftUserId

    const selectOptions = {
      value: driftUserId,
      pageSize: 10,
      searchable: true,
      placeholder: "Select Drift User..",
      options: this.props.driftUsers,
      onChange: (value) => saveUserOption(value, index),
      onNewOptionClick: () => openInviteModal(index),
      promptTextCreator: () => (
        <div className="select-invite-link">
          <p>Invite New Teammate</p>
        </div>
      ),
    }

    return (
      <Creatable {...selectOptions} />
    )
  }

  render() {
    const { index, onMappingRemove } = this.props

    return (
      <tr>
        <td>{this.renderIntegrationUserDropdown()}</td>
        <td className="integration-user-mapping-table-seperator"><div /></td>
        <td>{this.renderDriftUserDropdown()}</td>
          <td className="integration-user-mapping-actions">
            <span onClick={() => onMappingRemove(index)}>
              <Icon width={15} name="close"/>
            </span>
          </td>
      </tr>
    )
  }

}

export default OwnerMappingRow


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/OwnerMapper/OwnerMappingRow/index.js